import { render, staticRenderFns } from "./GestaoDaAtaView.vue?vue&type=template&id=15b62e18&scoped=true"
import script from "./GestaoDaAtaView.vue?vue&type=script&lang=js"
export * from "./GestaoDaAtaView.vue?vue&type=script&lang=js"
import style0 from "./GestaoDaAtaView.vue?vue&type=style&index=0&id=15b62e18&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b62e18",
  null
  
)

export default component.exports